import { Component, Input } from '@angular/core';
import { TicketInfo } from '../../pages/event-ticket/event-ticket.model';

/**
 * Generated class for the EventTicketQrComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'event-ticket-qr',
  templateUrl: 'event-ticket-qr.html'
})
export class EventTicketQrComponent {

  @Input() value: string;

  constructor() {
    
  }

}



// WEBPACK FOOTER //
// ./src/components/event-ticket-qr/event-ticket-qr.ts